import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const PlusIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path d="M2.5 8h11M8 2.5v11" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
))

export default PlusIcon
